import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { Module } from './index';
import { CarouselNav, Grid } from '../ui';
import { black, cssColorValue, KeyboardDetectionProvider, cssSpacing, white, } from '@spotify-internal/encore-web';
import { ColorSetWrapper } from '../ui/Colors/Colors';
const Carousel = styled.div `
  color: ${cssColorValue('textBase')};
  background-color: ${cssColorValue('backgroundBase')};

  transition: background-color 0.5s, color 0.5s;
  padding-bottom: ${cssSpacing('looser')};
`;
const Slides = styled.div `
  grid-column: 1 / -1;
  display: grid;
`;
const Crossfade = css `
  visibility: ${({ active }) => (active ? 'visible' : 'hidden')};
  opacity: ${({ active }) => (active ? 1 : 0)};
  z-index: ${({ active }) => (active ? 1 : 'unset')};
  transition: visibility 0.5s, opacity 0.5s ease-in-out, z-index 0s 0.5s;
`;
const Slide = styled.div `
  grid-column: 1;
  grid-row: 1;
  ${Crossfade}
  display: grid;
  & > div {
    background-color: inherit;
    color: inherit;
    padding-bottom: ${cssSpacing('looser-2')};
  }
`;
const NavContainer = styled(Grid) `
  background-color: inherit;
  color: inherit;
  & > * {
    grid-column: 1 / -1;
  }
`;
export const ModuleCarousel = React.forwardRef(({ slides = [], onShowSlide = () => { }, shouldAnimate }, _) => {
    var _a, _b;
    const moduleRefs = [];
    const getModuleWithRef = (mod, index) => {
        moduleRefs[index] = React.useRef();
        return (React.createElement(Module, { ...mod, shouldAnimate: shouldAnimate, ref: moduleRefs[index] }));
    };
    const [currentIndex, setCurrentIndex] = useState(0);
    const currentSlide = slides[currentIndex];
    const handlePrev = () => {
        const idx = Math.max(currentIndex - 1, 0);
        onShowSlide(slides[idx], idx);
        setCurrentIndex(idx);
    };
    const handleNext = () => {
        const idx = Math.min(currentIndex + 1, slides.length - 1);
        onShowSlide(slides[idx], idx);
        setCurrentIndex(idx);
    };
    const formattedColors = {
        backgroundColor: ((_a = currentSlide === null || currentSlide === void 0 ? void 0 : currentSlide.colors) === null || _a === void 0 ? void 0 : _a.backgroundColor) ||
            (currentSlide === null || currentSlide === void 0 ? void 0 : currentSlide.backgroundColor) ||
            white,
        textColor: ((_b = currentSlide === null || currentSlide === void 0 ? void 0 : currentSlide.colors) === null || _b === void 0 ? void 0 : _b.textColor) || (currentSlide === null || currentSlide === void 0 ? void 0 : currentSlide.textColor) || black,
    };
    return (React.createElement(KeyboardDetectionProvider, null,
        React.createElement(ColorSetWrapper, { colors: formattedColors },
            React.createElement(Carousel, null,
                React.createElement(Slides, null, slides.map((module, index) => (React.createElement(Slide, { key: index, active: currentIndex === index }, getModuleWithRef(module, index))))),
                React.createElement(NavContainer, null,
                    React.createElement(CarouselNav, { index: currentIndex + 1, total: slides.length, handlePrev: handlePrev, handleNext: handleNext, hexColor: formattedColors.textColor }))))));
});
